module.exports = __webpack_public_path__ + "img/type_2.7ead2896.png";